import { App, Button, Popconfirm, Spin } from "antd";

const DeleteWithAsking = ({
  buttonText,
  titleText,
  descriptionText,
  mutationFn,
  isLoading,
}) => {
  const { notification } = App.useApp();
  const onClick = () => {
    mutationFn.mutate(
      {},
      {
        onSuccess: () => {
          notification.success({
            message: "Die Datenbank wurde erfolgreich bereinigt!",
          });
        },
        onError: () => {
          notification.error({
            message: "Die Datenbank konnte nicht bereinigt werde",
          });
        },
      }
    );
  };

  return (
    <Popconfirm
      title={titleText}
      description={descriptionText}
      okText="Ja"
      cancelText="Nein"
      onConfirm={onClick}
    >
      <Button
        htmlType="submit"
        danger
        disabled={isLoading.delete || isLoading.export || isLoading.import}
      >
        {isLoading.delete ? (
          <div>
            <Spin /> Löschen...
          </div>
        ) : (
          buttonText
        )}
      </Button>
    </Popconfirm>
  );
};

export default DeleteWithAsking;
